var moduleMap = {
	"./ShellState": () => {
		return Promise.all(/* __federation_expose_ShellState */[__webpack_require__.e(194), __webpack_require__.e(21), __webpack_require__.e(477)]).then(() => (() => ((__webpack_require__(1639)))));
	},
	"./ShellEventBus": () => {
		return __webpack_require__.e(/* __federation_expose_ShellEventBus */ 56).then(() => (() => ((__webpack_require__(6708)))));
	},
	"./ESABus": () => {
		return __webpack_require__.e(/* __federation_expose_ESABus */ 557).then(() => (() => ((__webpack_require__(690)))));
	},
	"./SurfaceContract": () => {
		return Promise.all(/* __federation_expose_SurfaceContract */[__webpack_require__.e(550), __webpack_require__.e(932), __webpack_require__.e(194), __webpack_require__.e(437), __webpack_require__.e(21), __webpack_require__.e(271)]).then(() => (() => ((__webpack_require__(7069)))));
	},
	"./CanvasEngine": () => {
		return Promise.all(/* __federation_expose_CanvasEngine */[__webpack_require__.e(550), __webpack_require__.e(72), __webpack_require__.e(932), __webpack_require__.e(194), __webpack_require__.e(437), __webpack_require__.e(21), __webpack_require__.e(271), __webpack_require__.e(426)]).then(() => (() => ((__webpack_require__(7330)))));
	},
	"./i18n": () => {
		return Promise.all(/* __federation_expose_i18n */[__webpack_require__.e(34), __webpack_require__.e(844)]).then(() => (() => ((__webpack_require__(1080)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});